
import XTextarea from 'vux/src/components/x-textarea/index.vue'

export default {
components: {
XTextarea
}

}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-text.vue